import './ProjectDetailsImagesListThumbs.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEdit, faUnlink } from '@fortawesome/free-solid-svg-icons';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Pagination } from '../../../../../../design/pagination/S_Pagination';
import { Thumbnails } from '../../../../../../design/thumbnails/Thumbnails';
import { SpaceBetweenColumnLayout } from '../../../../../../modules/common/layouts/spaceBetweenColumnLayout/SpaceBetweenColumnLayout';
import { Loader } from '../../../../../components/Loader';
import { scrollTop } from '../../../../../helpers/react.helpers';
import { IProjectDetailsImage } from '../projectDetailsImages.model';
import { ImagesListThumbnail } from './ImagesListThumbnail';
import { IProjectDetailsImagesListProps } from './ProjectDetailsImagesList';

library.add(faUnlink, faEdit);

export const ProjectDetailsImagesListThumbs = observer((props: IProjectDetailsImagesListProps): ReactElement => {
  const { t } = useTranslator();

  const handleChange = async (pageNumber: number, pageSize: number): Promise<void> => {
    scrollTop();
    await props.pagination.onChange(pageNumber, pageSize);
  };

  return (
    <div className='project-details-images'>
      <Loader isLoading={props.isLoading} />
      {props.detailsImages.length === 0 && !props.isLoading && <div className='no-image-message'>{t('no_images')}</div>}
      {props.detailsImages.length > 0 && (
        <SpaceBetweenColumnLayout className='thumbnails-container'>
          <Thumbnails isLoading={props.isLoading}>
            {!props.isLoading &&
              props.detailsImages.map((image: IProjectDetailsImage) => {
                const isInList = props.toggledImages.some((id) => id === image.id);
                return (
                  <ImagesListThumbnail
                    key={image.id}
                    filterId={props.filterId}
                    image={image}
                    projectId={props.projectId}
                    authToken={props.authToken}
                    onCheck={props.onCheck}
                    isChecked={!image.isLocked && ((isInList && props.selectionMode === 'Select') || (!isInList && props.selectionMode === 'Deselect'))}
                    workspaceId={props.workspaceId}
                    onImageSetChange={props.onImageSetChange}
                  />
                );
              })}
          </Thumbnails>
          <S_Pagination
            {...props.pagination}
            onChange={handleChange}
            pageSizeLabel='pagination.showImages'
          />
        </SpaceBetweenColumnLayout>
      )}
    </div>
  );
});
